var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-list-group",
    [
      _c(
        "b-list-group-item",
        [
          _c("router-link", { attrs: { to: { name: "BrandListClient" } } }, [
            _vm._v("Clientes por marcas")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-list-group-item",
        [
          _c("router-link", { attrs: { to: { name: "BrandListOffices" } } }, [
            _vm._v("Oficinas por marca")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-list-group-item",
        [
          _c("router-link", { attrs: { to: { name: "BrandListModels" } } }, [
            _vm._v("Modelos por marca")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-list-group-item",
        [
          _c("router-link", { attrs: { to: { name: "BrandList" } } }, [
            _vm._v("Marcas")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-list-group-item",
        [
          _c("router-link", { attrs: { to: { name: "Contacts" } } }, [
            _vm._v("Contacto")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-list-group-item",
        [
          _c("router-link", { attrs: { to: { name: "TestDrives" } } }, [
            _vm._v("Test Drive")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-list-group-item",
        [
          _c("router-link", { attrs: { to: { name: "Register" } } }, [
            _vm._v("Registro de Usuarios")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-list-group-item",
        [
          _c("router-link", { attrs: { to: { name: "UsersList" } } }, [
            _vm._v("Lista de Usuarios")
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9bcc0be2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bcc0be2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menu.vue
// module id = null
// module chunks = 